<template>
  <div
    v-if="['sm', 'xs'].includes($mq)"
    class="root mobile clickable rounded-circle text-white"
    @click="$store.dispatch('openQuestionModal')"
  >
    <i class="icon fa fa-question" aria-hidden="true" />
  </div>
  <div
    v-else
    class="root square clickable rounded-right text-white"
    @click="$store.dispatch('openQuestionModal')"
  >
    <div class="text-wrapper">
      <div class="text">{{ $t('MODAL_askPhysio_question') }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'navigation',
  computed: {
    ...mapState(['language']),
  },
};
</script>

<style lang="scss" scoped>
@import 'node_modules/bootstrap/scss/functions';
@import 'node_modules/bootstrap/scss/bootstrap';
@import '/../theme';

.root {
  position: fixed;
  z-index: 1000;
  width: 40px;
  height: 170px;
  background-color: theme-color('primary');
  transition: background 0.15s;

  &:hover {
    background-color: theme-color-level('primary', 3);
  }
}

.mobile {
  bottom: 40px;
  right: 10px;
  width: 50px;
  height: 50px;
  text-align: center;

  .icon {
    line-height: 50px;
    font-size: 25px;
    padding-right: 2px;
  }
}

.square {
  top: 35%;
  left: 0;
  width: 40px;
  height: 170px;
}

.text-wrapper {
  transform: rotate(-90deg);
  margin-left: -4px;
}

.text {
  text-align: center;
  width: 170px;
  margin-left: -136px;
}
</style>



// WEBPACK FOOTER //
// src/components/AskPhysio.vue